import React from 'react';
import { useParams, Navigate, Link } from 'react-router-dom';
import { MapPin, Phone, Check, ArrowRight } from 'lucide-react';
import { Reveal } from '../hooks/useReveal';
import { IMAGES, CLUBS, IMG_FOCUS } from '../data/mock';
import TrialCTA from '../components/TrialCTA';

export default function ClubPage() {
  const { slug } = useParams();
  const club = CLUBS[slug];
  if (!club) return <Navigate to="/" replace />;

  return (
    <>
      <section className="relative pt-32 pb-16 md:pt-56 md:pb-32 overflow-hidden">
        <div className="absolute inset-0">
          <img src={IMAGES[club.hero]} alt={club.name} loading="eager" fetchpriority="high" decoding="async" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0a0a0a] via-[#0a0a0a]/80 to-[#0a0a0a]/40" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] to-transparent" />
        </div>
        <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
          <p className="hx-eyebrow mb-4 flex items-center gap-2"><MapPin size={14} />{club.city}</p>
          <h1 className="font-display text-5xl md:text-7xl lg:text-8xl leading-[0.9]">{club.name}</h1>
          <p className="text-[var(--hx-muted)] text-lg md:text-xl max-w-xl mt-5">{club.tagline}</p>
          <div className="flex flex-wrap gap-6 mt-7">
            <a href="#" className="flex items-center gap-2 text-sm text-[var(--hx-text)]"><MapPin size={16} className="text-accent" />{club.address}</a>
            <a href={`tel:${club.phone}`} className="flex items-center gap-2 text-sm text-[var(--hx-text)]"><Phone size={16} className="text-accent" />{club.phone}</a>
          </div>
        </div>
      </section>

      <section className="py-14 md:py-24 max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12">
          <Reveal>
            <p className="hx-eyebrow mb-4">Les équipements</p>
            <h2 className="font-display text-3xl md:text-5xl leading-[0.95] mb-7">Tout pour performer</h2>
            <ul className="space-y-4">
              {club.features.map((f) => (
                <li key={f} className="flex items-center gap-3 text-lg">
                  <span className="w-7 h-7 grid place-items-center bg-accent/10 border border-accent/30 rounded-full shrink-0"><Check size={15} className="text-accent" /></span>
                  {f}
                </li>
              ))}
            </ul>
          </Reveal>
          <div className="grid grid-cols-2 gap-4">
            {club.gallery.map((g, i) => (
              <Reveal key={g} delay={i * 90} className={i === 0 ? 'col-span-2' : ''}>
                <img src={IMAGES[g]} alt="" loading="lazy" decoding="async" style={{ objectPosition: IMG_FOCUS[g] || 'center' }} className={`w-full object-cover rounded-md ${i === 0 ? 'h-56' : 'h-40'}`} />
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-14 md:py-24 bg-[#0d0d0d]">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <Reveal className="mb-10">
            <p className="hx-eyebrow mb-4">Planning</p>
            <h2 className="font-display text-3xl md:text-5xl leading-[0.95]">Les créneaux de la semaine</h2>
          </Reveal>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {club.schedule.map((d, i) => (
              <Reveal key={d.day} delay={(i % 4) * 70}>
                <div className="hx-card rounded-md p-5 h-full">
                  <h3 className="font-cond tracking-widest text-sm text-accent border-b border-[#262626] pb-3 mb-3">{d.day}</h3>
                  <div className="flex flex-wrap gap-2">
                    {d.slots.map((s) => (
                      <span key={s} className="px-2.5 py-1 bg-[#1a1a1a] border border-[#262626] rounded text-sm font-cond tracking-wide">{s}</span>
                    ))}
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal className="mt-10">
            <Link to="/reserver" className="hx-btn">Réserver dans cette salle <ArrowRight size={18} /></Link>
          </Reveal>
        </div>
      </section>

      <TrialCTA />
    </>
  );
}
